import React, { useState, useEffect, useCallback, createContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import "@/App.css";
import ErrorBoundary from "./components/ErrorBoundary";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import RecipeDetail from "./pages/RecipeDetail";
import Profile from "./pages/Profile";
import Menu from "./pages/Menu";
import LegalPage from "./pages/LegalPage";
import ResetPassword from "./pages/ResetPassword";
import FAQ from "./pages/FAQ";
import Admin from "./pages/Admin";
import ShareTarget from "./pages/ShareTarget";
import Discover from "./pages/Discover";

// Auto-détection de l'URL du backend basée sur le domaine actuel
const getBackendUrl = () => {
  const hostname = window.location.hostname;
  
  // Si on est sur smartbouffe.com (production), utiliser le même domaine
  if (hostname === 'www.smartbouffe.com' || hostname === 'smartbouffe.com') {
    return window.location.origin;
  }
  
  // Si on est sur un domaine emergent.host (déploiement Emergent)
  if (hostname.endsWith('.emergent.host')) {
    return window.location.origin;
  }
  
  // Sinon utiliser la variable d'environnement (preview/development)
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export { API };
export const AuthContext = createContext();

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (loading) {
    return (
      <div className="loading-screen" data-testid="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <AuthContext.Provider value={{ user, setUser, checkAuth }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Landing />} />
            <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/" />} />
            <Route path="/discover" element={user ? <Discover /> : <Navigate to="/" />} />
            <Route path="/recipe/:id" element={user ? <RecipeDetail /> : <Navigate to="/" />} />
            <Route path="/profile" element={user ? <Profile /> : <Navigate to="/" />} />
            <Route path="/menu" element={user ? <Menu /> : <Navigate to="/" />} />
            <Route path="/admin" element={user ? <Admin /> : <Navigate to="/" />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/share" element={<ShareTarget />} />
            <Route path="/legal/:type" element={<LegalPage />} />
          </Routes>
        </BrowserRouter>
      </AuthContext.Provider>
    </ErrorBoundary>
  );
}

export default App;